<template>
  <v-list dense class="sidemenu">
    <div
      v-for="(menu, ind) in items"
      :key="ind"
      :class="menu.route === mainPage ? 'active-menu' : ''"
    >
    <!-- <div
      v-for="(menu, ind) in filteredPermission(items)"
      :key="ind"
      :class="menu.route === mainPage ? 'active-menu' : ''"
    > -->
      <a
        v-if="menu.children.length == 0 && (menu.externalLink || menu.route)"
        :href="menu.externalLink ? menu.externalLink : mainSite + menu.route"
        :target="menu.externalLink ? '_blank' : ''"
        class="d-flex"
      >
        <v-list-item class="list-item-menu">
          <!-- ไม่มี children -->
          <template>
            <v-list-item-icon>
              <span class="material-symbols-outlined"> {{ menu.icon }} </span>
            </v-list-item-icon>
            <v-list-item-content>
              <span class="font-14">
                {{ menu.name }}
              </span>
            </v-list-item-content>
          </template>
        </v-list-item>
      </a>

      <div
        v-if="menu.children.length == 0 && (!menu.externalLink && !menu.route)"
        class="d-flex"
      >
        <v-list-item class="list-item-menu">
          <!-- ไม่มี children ไม่มีข้อมูล disable -->
          <template>
            <v-list-item-icon>
              <span class="material-symbols-outlined"> {{ menu.icon }} </span>
            </v-list-item-icon>
            <v-list-item-content>
              <span class="font-14">
                {{ menu.name }}
              </span>
            </v-list-item-content>
          </template>
        </v-list-item>
      </div>

      <!-- มี children -->
      <v-list-group
        v-if="menu.children.length != 0" 
        no-action
        :value="!!menu.children.find((x) => x.route === mainPage)"
        color="var(--theme-color-one)"
        class="txt-normal list-group-menu"
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <span class="material-symbols-outlined"> {{ menu.icon }} </span>
          </v-list-item-icon>
          <v-list-item-content class="font-14">
            {{ menu.name }}
          </v-list-item-content>
        </template>

        <div v-for="(submenu, i) in menu.children" :key="i" class="pl-4">
          <a v-if="(submenu.externalLink || submenu.route)"
            :href="
              submenu.externalLink ? submenu.externalLink : (mainSite +
              submenu.route +
              (menu.name === 'คำร้อง' ? checkQuery(submenu) : ''))
            "
             :target="submenu.externalLink ? '_blank' : ''"
          >
            <v-list-item
              dense
              link
              mandatory
              class="d-flex align-center"
              :class="submenu.route === mainPage ? 'active-sub-menu' : ''"
            >
              <v-icon
                :color="
                  submenu.route === mainPage ? 'var(--theme-color-one)' : ''
                "
                class="mr-4"
                style="font-size: 5px"
              >
                mdi-checkbox-blank-circle
              </v-icon>
              <span>{{ submenu.name }}</span>
            </v-list-item>
          </a>

          <div v-if="(!submenu.externalLink && !submenu.route)"
            :href="
              mainSite +
              submenu.route +
              (menu.name === 'คำร้อง' ? checkQuery(submenu) : '')
            "
          >
            <v-list-item
              dense
              link
              mandatory
              class="d-flex align-center"
              :class="submenu.route === mainPage ? 'active-sub-menu' : ''"
            >
              <v-icon
                :color="
                  submenu.route === mainPage ? 'var(--theme-color-one)' : ''
                "
                class="mr-4"
                style="font-size: 5px"
              >
                mdi-checkbox-blank-circle
              </v-icon>
              <span>{{ submenu.name }}</span>
            </v-list-item>
          </div>
        </div>
      </v-list-group>
    </div>
  </v-list>
</template>

<script>
import { mainPage, mainSite, controllerName } from "@/store/constants"
import { mapState } from "vuex"

export default {
  data() {
    return {
      mainPage,
      mainSite,
      encryptSoldTo: "",
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  created() {},
  computed: {
    ...mapState({
      userInfo: (state) => state.Auth.userInfo,
    }),
  },
  methods: {
    checkQuery(submenu) {
      return submenu.query ? "?category=" + submenu.query : "";
    },
    filteredPermission (items) {
      if (items) {
        return items.filter(x => x.deniedRoles && !x.deniedRoles.includes(this.userInfo.Role__c))
      }
      return []
    }
  },
};
</script>

<style lang="scss">
.sidemenu {
  box-shadow: 0 -1px 2px rgba(145, 158, 171, 0.24),
    0 1px 2px rgba(145, 158, 171, 0.24);

  a {
    text-decoration: none;
    color: var(--theme-color-one);
  }

  .list-group-menu {
    .v-list-item {
      // padding: 0px !important;
      // margin-left: -15px;
    }
  }
  .list-item-menu.v-list-item.theme--light {
    border-left: 3px solid white !important;
  }
  .list-item-menu.v-list-item.theme--light:hover {
    background-color: #e4e4e4;
    cursor: pointer;
    border-left: 3px solid #e4e4e4 !important;
  }
  // set active menu
  .v-list-group__header.v-list-item.v-list-item--active.v-list-item--link.theme--light {
    background: #e9f4e6 !important;
    color: var(--theme-color-one) !important;
    border-left: 3px solid var(--theme-color-one) !important;
    // margin-left: -1px !important;
  }
  .v-list-group__header.v-list-item.v-list-item--link.theme--light {
    // border-left: 3px solid transparent !important;
    border-left: 3px solid white !important;
  }
  .v-list-group__header.v-list-item.v-list-item--link.theme--light:hover {
    // background-color: #e4e4e4 !important;
  }
}
.active-menu {
  background: #e9f4e6;
  .list-item-menu {
    color: var(--theme-color-one) !important;
  }
}
.active-sub-menu {
  color: var(--theme-color-one) !important;
}
</style>
